export default __webpack_public_path__ + "static/media/img-slider-smart-signage-3.b475fbba.png";